import { Alert } from '@mui/material';
import type { ErrorComponentProps } from '@tanstack/react-router';

import { FC } from 'react';

export const DefaultErrorComponent: FC<ErrorComponentProps> = () => (
  <Alert severity='error'>An unexpected error occurred.</Alert>
);

DefaultErrorComponent.displayName = 'DefaultErrorComponent';
